import { render, staticRenderFns } from "./BusinessContactTopicCreate.vue?vue&type=template&id=3c2ba7ce"
import script from "./BusinessContactTopicCreate.vue?vue&type=script&lang=js"
export * from "./BusinessContactTopicCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports